// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "-" + {"126":"f83130f64ff253f9984c","245":"a401e1145d7a1b3e3cc3","669":"86aba6ece053ad384372","748":"9747e5cd8d34ba89367b"}[chunkId] + ".js";
};